import { render } from "./WizardStyles.vue?vue&type=template&id=02473170"
import script from "./WizardStyles.vue?vue&type=script&lang=js"
export * from "./WizardStyles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__